var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import merge from 'lodash-es/merge';
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { HttpClient } from "@angular/common/http";
import { EventsService } from "app/lib/EventsService";
import * as qs from 'qs';
import { BaseComponent } from "app/views/base.component";
import { ModalService } from "app/views/modal/base_modal.component";
import { HelperService } from "app/lib/helper.service";
import { getSiteStatusStyle } from "../../lib/lib";
import * as moment from "moment-timezone";
import { AlertComponent } from "../../views/modal/alert.component";
import { SitesService } from "../sites.service";
var DOWNLOAD_TYPE = { phone: true, app: true, domain: true, all: true };
var PublishedSiteComponent = /** @class */ (function (_super) {
    __extends(PublishedSiteComponent, _super);
    function PublishedSiteComponent(eventsService, activatedRoute, translate, router, modalService, filter, http, helper, siteService) {
        var _this = _super.call(this, eventsService, siteService, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.http = http;
        _this.helper = helper;
        _this.siteService = siteService;
        _this.sort = { 'date_create': 'desc' };
        _this.typeDate = 'dateCreate';
        _this.loadingInProgress = false;
        _this.baseUrl = _this.router.url.split('?')[0];
        _this.totalCount = 0;
        _this.filterCount = 0;
        _this.addFilterParams = {
            userType: 'user',
            dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated', 'dateTo'],
            dateType: 'datePaid',
            typeDate: 'dateCreate'
        };
        _this.moment = moment;
        _this.getSiteStatusStyle = getSiteStatusStyle;
        return _this;
    }
    PublishedSiteComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.sort = merge({}, this.filter.filterParams['sort'], this.sort);
                        this.typeDate = this.filter.filterParams['typeDate'];
                        return [4 /*yield*/, this.getPagination()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getTotal()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PublishedSiteComponent.prototype.applyFilter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                        this.filter.filterParams['sort'] = this.sort;
                        this.filter.filterParams['typeDate'] = this.typeDate;
                        this.filter.filterParams['page'] = this.pagination.page;
                        params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                        params = qs.stringify(params, { encode: false });
                        return [4 /*yield*/, this.router.navigateByUrl(url + "?" + params, { relativeTo: this.activatedRoute })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PublishedSiteComponent.prototype.getTotal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, _a, totalCount, count;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        me.totalLoader = true;
                        return [4 /*yield*/, me.siteService.publishedSite.total(this.filter.filterParams).toPromise()];
                    case 1:
                        _a = _b.sent(), totalCount = _a.totalCount, count = _a.count;
                        me.totalLoader = false;
                        me.totalCount = totalCount;
                        me.filterCount = count;
                        return [2 /*return*/];
                }
            });
        });
    };
    PublishedSiteComponent.prototype.getPagination = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, pagination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        if (!this.dontLoad.pagination) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getStats()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 2:
                        if (!(this.filter.filterParams.period !== 'summary')) return [3 /*break*/, 4];
                        this.paginationLoader = true;
                        return [4 /*yield*/, this.siteService.publishedSite.pagination(this.filter.filterParams).toPromise()];
                    case 3:
                        pagination = _a.sent();
                        me.pagination.fill(pagination);
                        if (pagination) {
                            me.updateLinks(me.siteService.publishedSite.getRealFullRoute());
                        }
                        this.paginationLoader = false;
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.getStats()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PublishedSiteComponent.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        if (this.pagination.pageCount === 0) {
                            return [2 /*return*/];
                        }
                        me.loadingInProgress = true;
                        return [4 /*yield*/, this.siteService.publishedSite.stats(this.filter.getCopyFilterParams({
                                paginationDate: me.pagination.getDate()
                            })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        me.loadingInProgress = false;
                        me.stats = stats;
                        this.dontLoad = {};
                        return [2 /*return*/];
                }
            });
        });
    };
    PublishedSiteComponent.prototype.downloadButton = function (t) {
        var fp = {};
        var action = '';
        if (t === 'cc') {
            fp = {
                fieldList: [
                    'dateCreate',
                    'lastInvoiceDateTo',
                    'username',
                    'email',
                    'domainUrl',
                    'domains',
                    'phonesFromUser',
                    'phonesFromSites',
                    'phonesFromExternalData'
                ],
                reportGUID: this.filter.reportGUID,
            };
        }
        else {
            fp = {
                reportGUID: this.filter.reportGUID,
            };
        }
        if (t === 'cc' || t === 'data') {
            action = 'csv';
        }
        else if (t === 'apps') {
            action = 'user_app_csv';
        }
        else {
            action = 'domains_csv';
        }
        window.location.href = this.siteService.publishedSite.downloadFileRoute(this.filter.getCopyFilterParams(fp), action);
        this.modalService.open(AlertComponent, {
            title: 'INFO',
            message: this.translate.__A('common.download file')
        });
    };
    PublishedSiteComponent.prototype.total = function (sites) {
        if (sites) {
            return sites.reduce(function (total, site) {
                return parseInt(total) + parseInt(site.count);
            }, 0);
        }
        return 0;
    };
    /**
     * Скачать данные по сайтам в виде CSV
     * @param type Тип выборки (уточнить у Артёма)
     */
    PublishedSiteComponent.prototype.download = function (type) {
        var me = this;
        if (!DOWNLOAD_TYPE[type]) {
            throw new Error("download: type '" + type + "'is not correct");
        }
        window.location.href = me.siteService.publishedSite.downloadFileRoute(me.filter.getCopyFilterParams({ type: type }), 'download');
        me.modalService.open(AlertComponent, {
            title: 'INFO',
            message: this.translate.__A('common.download file')
        });
    };
    PublishedSiteComponent.prototype.onPageChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.filter.filterParams.page = this.pagination.page;
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.activatedRoute });
                this.dontLoad = {
                    pagination: true
                };
                return [2 /*return*/];
            });
        });
    };
    PublishedSiteComponent.prototype.getSortClasses = function (sortFiledName) {
        if (!sortFiledName) {
            return;
        }
        if (this.sort[sortFiledName] === 'asc') {
            return 'fa-sort-amount-up';
        }
        if (this.sort[sortFiledName] === 'desc') {
            return 'fa-sort-amount-down';
        }
        return 'fa-sort';
    };
    PublishedSiteComponent.prototype.toggleSort = function (sortFiledName) {
        return __awaiter(this, void 0, void 0, function () {
            var sortDirection;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!sortFiledName) {
                            return [2 /*return*/];
                        }
                        sortDirection = this.sort[sortFiledName];
                        this.sort = {};
                        this.sort[sortFiledName] = sortDirection === 'asc' ? 'desc' : 'asc';
                        return [4 /*yield*/, this.applyFilter()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return PublishedSiteComponent;
}(BaseComponent));
export { PublishedSiteComponent };
